import { createSlice } from "@reduxjs/toolkit";

const initialStateObj = {
    gender: [],
    maritalstatus: [],
    profile: [],
    candidatestatus: [],
    countries: [],
    states: [],
    cities: [],
    technologies: { technology: [] },
    workstatus: [],
    jobtitles: { job: [] },
    legalstatuses: { legal: [] },
    employmentstatuses: { employment: [] },
    notes_type: [],
    pay_type: [],
    generic_status: [],
    lastUpdated: null,
};

// Check if there is a value in localStorage
const getInitialValue = () => {
    const storedValue = localStorage.getItem('reference');
    if (storedValue) {
        try {
            const parsed = JSON.parse(storedValue);
            // Handle both old format (with wrapper) and new format (just the value)
            // Old format: { id, client, company, type, value: {...config...} }
            // New format: {...config...}
            if (parsed.value && typeof parsed.value === 'object') {
                // Old format - extract the value property
                return parsed.value;
            }
            return parsed;
        } catch (e) {
            console.error('Error parsing reference from localStorage:', e);
            return initialStateObj;
        }
    }
    return initialStateObj;
};

const initialState = getInitialValue();

const referenceSlice = createSlice({
    name: "reference",
    initialState,
    reducers: {
        setReference: (state, action) => {
            // Return new state with all payload properties plus timestamp
            // This properly replaces the entire state in Immer
            return {
                ...action.payload,
                lastUpdated: Date.now(),
            };
        },
        clearReference: () => {
            return initialStateObj;
        },
    },
});

export const { setReference, clearReference } = referenceSlice.actions;
export default referenceSlice.reducer;
